import { datetimeCovertertolocal } from '../../datetime-converter';
import { ADD_BATCH, ADD_BATCH_SUCCESS, ADD_BATCH_ERROR, EDIT_BATCH_ERROR, EDIT_BATCH_SUCCESS, EDIT_BATCH, BATCH_DETAILS, BATCH_DETAILS_SUCCESS, BATCH_DETAILS_ERROR, DELETE_BATCH, DELETE_BATCH_SUCCESS, DELETE_BATCH_ERROR, EVENT_BATCH_LIST_ERROR, EVENT_BATCH_LIST_SUCCESS, EVENT_BATCH_LIST, EVENTVERIFIER_LIST, EVENTVERIFIER_LIST_SUCCESS, EVENTVERIFIER_LIST_ERROR, EVENTVERIFIER_LIST_DETAILS, EVENTVERIFIER_LIST_DETAILS_SUCCESS, EVENTVERIFIER_LIST_DETAILS_ERROR, DELETE_EVENTVERIFIER_LIST, DELETE_EVENTVERIFIER_LIST_SUCCESS, DELETE_EVENTVERIFIER_LIST_ERROR } from './constants';


export default function eventbatchreducer(state, action) {
	
	let batch = [];
	let verfiedevents = [];
	let pagination = {};

	switch (action.type) {

	case EVENT_BATCH_LIST:
		return { ...state, loading : true, error : false};

	case EVENT_BATCH_LIST_SUCCESS:
		if(action?.payload){

			if(action?.payload){
				pagination.total = action.payload.total ? action.payload.total : 0;
				pagination.limit = action.payload.limit ? action.payload.limit : 10;
				pagination.skip = action.payload.skip ? action.payload.skip : 0;
				pagination.current = action.page ? action.page : 1;
				pagination.pageSize =  action.pageSize ? action.pageSize : 10;

			}
			action.payload.data.map((item) => {
				const startdate = datetimeCovertertolocal(item.startDatetime?item.startDatetime : '<Not Set>');
				const newstartdate = item.startDatetime ? (startdate.localdate + ' ' + startdate.localtime) : '<Not Set>';
					
				const enddate = datetimeCovertertolocal(item.endDatetime?item.endDatetime: '<Not Set>');
				const newenddate = item.endDatetime ? (enddate.localdate + ' ' + enddate.localtime) : '<Not Set>';

				
				batch.push({
					id : item && item?.id ? item.id : null,
					name : item && item?.name ?  item.name : '',
					channelname : item && item?.channelinfo ?  item && item?.channelinfo?.name : '',
					pidsinfoId :  item && item?.pidsinfoId ?  item && item?.pidsinfoId : null,
					channelinfoId: item && item?.channelinfoId ?  item && item?.channelinfoId : null,
					pidsname : item && item?.pidsinfo ?  item && item?.pidsinfo?.name : '',
					startDatetime : item && item?.startDatetime ? item?.startDatetime : '',
					endDatetime   : item && item?.endDatetime ? item?.endDatetime : '',
					newstartdate : newstartdate,
					newenddate : newenddate,
					status : item && item?.status ? item?.status : 'New' ,
					fiberMetric: item && item?.fiberMetric ? item?.fiberMetric : 'Index' ,
					analysisType: item && item?.analysisType ? item?.analysisType : 'Event' ,
					timeWindow: item && item?.timeWindow ? item?.timeWindow : null ,
					sampleSec: item && item?.sampleSec ? item?.sampleSec : null ,
					webhookUrl : item && item?.webhookUrl ? item?.webhookUrl : '' ,
					send : item && item?.send ?  item.send : false,
					isdataUploaded : item && item?.isdataUploaded ?  item.isdataUploaded : false,
					dataPath : item && item?.dataPath ?  item.dataPath : '',
					binSize: item && item?.binSize ?  item.binSize : 0,
					startPos:item && item?.startPos ?  item.startPos : 0,
					amplitudeNumber: item && item?.amplitudeNumber ?  item.amplitudeNumber : 0,
					confirmedEvent: item && item?.confirmedEvent ?  item.confirmedEvent : 'No Data',
					confirmedEventConfidence: item && item?.confirmedEventConfidence || item.confirmedEventConfidence == 0 ? item?.confirmedEventConfidence.toFixed(2) : 'N/A',
					referenceevent: item && item?.eventverifier && item?.eventverifier.length > 0 ? item?.eventverifier[0].referenceevent: 'No Data',
					eventPositionArray : item.eventverifier,

				});
			});
		}

		return {...state, batch : batch,  loading : false, error : false, pagination: pagination };

	case EVENT_BATCH_LIST_ERROR:
		return { ...state, batch : [], loading : false, error : true};

	case ADD_BATCH:
		return { ...state, loading: true };
	case ADD_BATCH_SUCCESS:
		return { ...state, loading: false, error: false };

	case ADD_BATCH_ERROR:
		return {...state, loading : false, error : true};

	case EDIT_BATCH:
		return { ...state, loading: true, error: false };

	case EDIT_BATCH_SUCCESS:
		return { ...state,  loading: false, error : false };

	case EDIT_BATCH_ERROR:
		return {...state, loading : false, error : true};

	case BATCH_DETAILS:
		return { ...state, loading: true };

	case BATCH_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };

	case BATCH_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_BATCH:
		return { ...state, loading: false };

	case DELETE_BATCH_SUCCESS:
		return { ...state, loading: false, error: false };

	case DELETE_BATCH_ERROR:
		return { ...state, loading: false, error: true };
	case EVENTVERIFIER_LIST:
		return { ...state, loading : true, error : false};

	case EVENTVERIFIER_LIST_SUCCESS:
		if(action?.payload){
			action.payload.map((item) => {
				
				verfiedevents.push({
					id : item && item?.id ?  item.id : null,
					text : item && item?.text ?  item.text : '',
					eventPosition : item && item?.eventPosition ?  item.eventPosition : null,
					referenceevent : item && item?.referenceevent ?  item.referenceevent : '',
					status: item && item?.status ?  item.status : 'New',
					referenceEventId : item && item?.referenceEventId ?  item.referenceEventId : null,
					verifiedEvent : item && item?.verifiedEvent ?  item.verifiedEvent : [],
					verifiedODmeter : item && item?.verifiedODmeter ?  item.verifiedODmeter : [],
					verifiedIndex : item && item?.verifiedIndex ?  item.verifiedIndex : [],
					verifiedConfidence :  item && item?.verifiedConfidence ?  item.verifiedConfidence : [],
					confirmedEvent: item && item?.confirmedEvent ?  item.confirmedEvent : 'No Data',
					confirmedEventConfidence: item && item?.confirmedEventConfidence || item.confirmedEventConfidence == 0 ? item?.confirmedEventConfidence.toFixed(2) : 'N/A',
					validatorEvent: item && item?.validatorEvent ?  item.validatorEvent : [],
					validatorConfidence:  item && item?.validatorConfidence ?  item.validatorConfidence : [],
					validatorProcessed: item && item?.validatorProcessed ? item?.validatorProcessed : false
				
				});
			});
		}

		return {...state, verfiedevents : verfiedevents,  loading : false, error : false};
	
	case EVENTVERIFIER_LIST_ERROR:
		return { ...state, verfiedevents : [], loading : false, error : true};

	case EVENTVERIFIER_LIST_DETAILS:
		return { ...state, loading: true };


	case EVENTVERIFIER_LIST_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };


	case EVENTVERIFIER_LIST_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_EVENTVERIFIER_LIST:
		return { ...state, loading: false };

	case DELETE_EVENTVERIFIER_LIST_SUCCESS:
		return { ...state, loading: false, error: false };

	case DELETE_EVENTVERIFIER_LIST_ERROR:
		return { ...state, loading: false, error: true };

	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}